






















































import {Component, Watch, Prop, Model} from 'vue-property-decorator';
  import { mixins } from 'vue-class-component';

  import ValidatableInputMixin from '@/components/ui/mixins/validatable-input-mixin';

  @Component
  export default class CreateUrlTagsInput extends mixins(ValidatableInputMixin) {
    @Model('change')
    url: string;

    @Prop()
    placeholder: any;
    
    @Prop(Array) 
    chips: any[];

    @Prop(String) 
    label: string;

    @Prop({ default: true })
    showToolTip: boolean;

    @Prop()
    toolTip: string;

    @Prop({ default: true })
    showQr: boolean;

    @Prop()
    textAreaRowsCount: number;

    @Prop({ default: false })
    disabled: boolean;

    qrLink: string = '<img src="https://api.qrserver.com/v1/create-qr-code/?size=177x177&margin=10&data=' + (this.url ? encodeURIComponent(this.url.trim()) : '') + '" alt="QR Code" border="0">';

    get tooltip() {
      return this.toolTip || this.t('It is required to use the {clickId} token if you want to track conversions.')
    }

    get changeUrl() {
      return this.url
    }

    set changeUrl(value) {
      this.url = value;
      this.changePostbackUrl();

      this.$emit('update:hasErrors', false);
    }

    @Watch('chips')
    onChipsChanged() {
      this.changePostbackUrl();
    }

    clickChip(item: any) {
      if (item.disabled || this.disabled) return
      //@ts-ignore
      const textArea = this.$refs.textarea.$el.getElementsByTagName('textarea');
      const { selectionStart: startPos, selectionEnd: endPos, value: tmpStr } = textArea[0]

      this.url = tmpStr.substring(0, startPos) + item.tag + tmpStr.substring(endPos, tmpStr.length);
      this.url = this.url.replace('+ ', '');
      this.changePostbackUrl();

      textArea[0].focus();
    }

    get availableTokens() {
      if(!this.url) return this.chips;
      return this.chips.map(item => {
        const disItem = item.tag.replace('+ ', '');
        item.disabled = !!(this.url.indexOf(disItem) + 1);
        return item;
      });
    }

    changePostbackUrl() {
      this.qrLink = '<img src="https://api.qrserver.com/v1/create-qr-code/?size=177x177&margin=10&data=' + (this.url ? encodeURIComponent(String(this.url).trim()) : '') + '" alt="QR Code" border="0">'
      this.$emit('change', this.url);
    }

  }
